import { MapPinCheck, School, Users, MessageCircle, House } from 'lucide-react';

const FEATURE_ITEMS = [
    {
        icon: MapPinCheck,
        title: "Local feed",
        description: "A short-form feed built around your city, so you can discover relevant content from the people and places around you.",
    },
    {
        icon: School,
        title: "Neighborhood News",
        description: "Hyper-local content that transforms your neighborhood into a digital community, with unlimited posts that keep everyone connected and in the loop.",
        comingSoon: true,
    },
    {
        icon: Users,
        title: "Groups",
        description: "Personalized spaces for people with like-minded interests looking for deeper engagement and discussion.",
        comingSoon: true,
    },
    {
        icon: MessageCircle,
        title: "Community Chat",
        description: "A real-time messaging space designed to bring people together for discussion and collaboration within your community.",
    },
    {
        icon: House,
        title: "Home Feed",
        description: "A personalized stream of content tailored to your interests, activities, and connections, helping you discover what matters most to you.",
    },
];

export default function OurFeatures() {
    return (
        <div className="h-full w-full overflow-y-auto">
            <div className="mx-auto w-full px-10 py-12 lg:py-16">
                <div className="mx-auto max-w-[520px] text-center">
                    <h1 className="text-[30px] font-black text-black">Our features</h1>
                    <p className="mt-2 text-[15px] text-[#7A7A7A]">
                        Everything you need to connect with your neighborhood and the people who share your interests.
                    </p>
                </div>

                <div className="mt-12 flex flex-wrap justify-center gap-x-12 gap-y-14">
                    {FEATURE_ITEMS.map((item) => (
                        <article key={item.title} className="w-full md:w-[calc(33.333%-2rem)]">
                            <div className="flex items-center gap-2">
                                <item.icon className="text-[28px] text-[#2996D6]" />
                                {item.comingSoon && (
                                    <span className="rounded-full bg-[#2996D6]/10 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide text-[#2996D6]">
                                        Coming soon
                                    </span>
                                )}
                            </div>
                            <h2 className="mt-4 text-[22px] font-black leading-none text-[#2A2A2A]">{item.title}</h2>
                            <p className="mt-3 text-[14px] text-[#767676]">{item.description}</p>
                        </article>
                    ))}
                </div>
            </div>
        </div>
    );
}
